import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { H3 } from 'components/core/Headline';
import { Text } from 'components/core/Text';
import { Image } from 'components/core/Image';

import outdoorUnit from 'assets/images/unit-icons/outdoor-unit.svg';
import outdoorCoveredUnit from 'assets/images/unit-icons/outdoor-covered-unit.svg';
import indoorUnit from 'assets/images/unit-icons/indoor-unit.svg';
import enclosedUnit from 'assets/images/unit-icons/enclosed-unit.svg';

import './vehicleAccomodationGuide.scss';

/* eslint-disable max-len */
const UNIT_SIZES = [
	{
		display: 'Outdoor Uncovered Unit',
		bucket: 'outdoor',
		image: outdoorUnit,
		description: "A Vehicle Parking Space is exactly what it sounds like: an area for you to park your vehicle. The parking area may be paved or on a variety of unpaved surfaces including gravel, dirt, or an open field on the storage facility's grounds."
	}, {
		display: 'Outdoor Covered Unit',
		bucket: 'outdoor-covered',
		image: outdoorCoveredUnit,
		description: "With Covered vehicle storage, you'll typically park your vehicle under a standalone roof alongside other vehicles, though some covered units do have three walls separating your vehicle from the rest. Though you won't get as much protection as from an enclosed unit or indoor, the roof structure will protect your vehicle from the harshest elements."
	}, {
		display: 'Indoor Unit',
		bucket: 'indoor',
		image: indoorUnit,
		description: "With Covered vehicle storage, you'll typically park your vehicle under a standalone roof alongside other vehicles, though some covered units do have three walls separating your vehicle from the rest. Though you won't get as much protection as from an enclosed unit or indoor, the roof structure will protect your vehicle from the harshest elements."
	}, {
		display: 'Enclosed Unit',
		bucket: 'enclosed',
		image: enclosedUnit,
		description: 'Enclosed Vehicle Storage is the safest and most secure means of storing your vehicle. These are large self-storage units that essentially act as garages you can drive your vehicle straight into, and are accessed via a large roll-up door. Enclosed units provide protection from winter weather and prevent any unwanted access to your vehicle.'
	}
];
/* eslint-enable */

export default function VehicleAccommodationGuide({ className }) {
	return (
		<div className={classnames(className, 'vehicle-accommodation-guide')}>
			<H3 size="medium" strong>
				Vehicle Accommodation Guide
			</H3>
			<div className="vehicle-units">
				{UNIT_SIZES.map((unit) => (
					<div className="vehicle-unit" key={unit.bucket}>
						<div className={classnames('unit-icon-container', `${unit.bucket}`)}>
							<Image src={unit.image} className="unit-icon" />
						</div>
						<div className="unit-description">
							<Text strong>
								{unit.display}
							</Text>
							<Text size="tiny">
								{unit.description}
							</Text>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}

VehicleAccommodationGuide.propTypes = {
	className: PropTypes.string
};
